<template>
  <div class="recharge_wrap finance-page invest-page">
    <div class="red_top_bg">
      <button
        type="button"
        class="back_left"
        @click="$router.go(-1)"
      />
      <div class="big_tit">
        {{ $t('invest.recharge') }}
      </div>
      <button
        type="button"
        class="top_right"
        @click="$router.push('/moneybag')"
      >
        <van-icon
          name="bars"
          size="16"
        />
      </button>
    </div>
    <section class="balance">
      <div class="balance-top">
        <span>{{ $t('invest.availableBalance') }}</span>
        <button
          type="button"
          class="visibility-button"
          @click="eye = eye === 1 ? 0 : 1"
        >
          <van-icon
            :name="eye === 1 ? 'eye-o' : 'closed-eye'"
          />
        </button>
      </div>
      <p class="balance-amount">
        <span v-if="eye === 1">{{ utils_moneyMark() }}{{ balance }}</span>
        <span v-else>******</span>
      </p>
    </section>
    <form
      class="form"
      @submit.prevent="submit"
    >
      <section class="recharge_wrap">
        <p class="amount-title">
          {{ $t('invest.rechargeAmount') }}
        </p>
        <div class="amount-entry">
          <input
            v-model.trim="data.money"
            type="number"
            min="1"
            step="1"
            class="inp"
            :placeholder="$t('invest.rechargeAmount')"
            @input="changeAmount"
          >
          <span class="currency-mark">{{ payment.mark }}</span>
        </div>
        <div class="converted-amount">
          {{ actualAmount }}
        </div>
        <div class="quick_wrap">
          <div class="amount-grid">
            <button
              v-for="(v, k) in paynum"
              :key="k"
              type="button"
              :class="{ selected: Number(data.money) === v }"
              @click="changeAmount2(v)"
            >
              {{ v }}
            </button>
          </div>
        </div>
      </section>

      <!-- <div class="recharge_fs shadow">
				<div class="tit">
					{{$t('invest.paymentMethod')}}
				</div>
				<div v-for="(v, k) in config.payment" :key="k" class="item" @click="choose_type(k+1,v)">
					<div class="check" :class="k+1 == data.choose? 'checked' : ''" />
					<div class="re_icon"><img :src="v.logo" /></div>
					<div class="re_name">
						{{ v.name }}
					</div>
				</div>
			</div> -->
      <button
        type="submit"
        class="basic_btn sbtn"
      >
        {{ $t('income.paynow') }}
      </button>
    </form>
		
    <div
      v-if="data.channel!=5"
      class="tip shadow"
    >
      {{ $t('invest.tip') }}
    </div>
  </div>
</template>

<script>
	import Vue from 'vue';
	import {
		CountDown,
		Checkbox,
		RadioGroup,
		Icon,
		Radio
	} from 'vant';
	import Fetch from '../../utils/fetch'

	Vue.use(RadioGroup);
	Vue.use(Radio);
	Vue.use(CountDown).use(Checkbox).use(Icon);

	export default {
		name: "Invest",
		data() {
			return {
				time: 0,
				eye: 1,
				balance: 0.00,
				data: {
					choose: '',
					channel: '',
					money: '',
					id: '',
					reason:''
				},
				paynum:[100,200,300,500,1000,2000,3000,5000,10000,20000,30000,50000],
				payment:[],
				config: {},
				actualAmount:'',
			};
		},
		created() {
			this.$parent.footer('user', false);
		},
		mounted() {
			this.start();
			var num = this.$router.history.current.params.code;
			if(num && num>0){
				this.data.money= num;
			}
		},
		methods: {
			start() {
				Fetch('/user/recharge', {
					...this.data
				}).then((r) => {
					this.balance = r.data.money;
					this.config = r.data;
					this.config.min_recharge = parseInt(this.config.min_recharge);
					this.choose_type(1,r.data.payment[0]);
				});
			},
			checkLimit() {
				const key = 'invest_button';
				const ttl = 60;
				let now = Date.parse(new Date()) / 1000;
				let val = localStorage.getItem(key);
				if (!val) {
					val = JSON.stringify({
						'ttl': now + ttl
					})
					localStorage.setItem(key, val)
					return true;
				} else {
					val = JSON.parse(val);
					if (val['ttl'] > now) {
						return false;
					} else {
						val = JSON.stringify({
							'ttl': now + ttl
						})
						localStorage.setItem(key, val)
						return true;
					}
				}
			},
			choose_type(k, payment) {
				this.data.choose = k;
				this.data.channel = payment.type;
				this.data.id = payment.id;
				this.payment = payment;
				this.changeAmount();
			},
			submit() {
				
				// return false;
				if (!this.data.money || (this.data.money / this.payment.rate) < this.config.min_recharge) {
					this.$toast(this.$t('invest.rechargeAmountLow') + this.utils_moneyMark() + this.config
						.min_recharge + this.$t('invest.rechargeAmountLow1'));
					return false;
				}
				if (!this.data.channel) {
					this.$toast(this.$t('invest.paymentMethodEmpty'));
					return false;
				}
				
				// if (!this.data.reason&&this.data.channel!=5) {
				// 	this.$toast(this.$t('invest.sendAddress'));
				// 	return false;
				// }
				// if (!this.checkLimit()) {
				// 	this.$toast(this.$t('invest.overtop'));
				// 	return false;
				// }

				if (this.data.channel == 4) {
					this.$router.replace({
						path: '/invest/bank',
						query: {
							payment: this.payment.id,
							acmoney: (this.data.money / this.payment.rate).toFixed(2),
							money: this.data.money,
							id: this.data.id
						}
					})
					this.$router.push("/kefu");
					return;
				} else if (this.data.channel == 1) {
					// this.$router.replace({
					// 	path: '/invest/usdt',
					// 	query: {
					// 		payment: this.payment.id,
					// 		acmoney: (this.data.money / this.payment.rate).toFixed(2),
					// 		money: this.data.money,
					// 		id: this.data.id,
					// 		reason:this.data.reason
					// 	}
					// })
					Fetch('/user/recharge_type', {
						money: this.data.money,
						payment: this.payment.id,
						type: "1",
						reason: "",
						acmoney: (this.data.money / this.payment.rate).toFixed(2),
						id:this.data.id
					}).then(() => {
						  this.$router.push("/kefu");
						 //  if(r.data.payment.payurl!=''){
							// // window.open(r.data.payment.payurl,'_blank');
							// window.location.href = r.data.payment.payurl;
						 //  }
					});
					return;
				} else {
					//第三方支付
				  Fetch('/user/recharge_type', {
					money: this.data.money,
					payment: this.payment.id,
					acmoney: (this.data.money / this.payment.rate).toFixed(2),
					id:this.data.id
				  }).then(() => {
					  this.$router.push("/kefu");
					 //  if(r.data.payment.payurl!=''){
						// // window.open(r.data.payment.payurl,'_blank');
						// window.location.href = r.data.payment.payurl;
					 //  }
				  });
				}
				// Fetch('/user/invest/apply', {
				//     ...this.data
				// }).then(() => {
				//     this.$router.replace('/login');
				// });
			},
			changeAmount() {
				var num = 2;
				if(this.payment.type){
					if (this.payment.type == 1) {
						if (this.payment.rate > 10000) {
							num = 8;
						} else if (this.payment.rate > 1000) {
							num = 6;
						} else if (this.payment.rate > 10) {
							num = 4;
						}
						this.actualAmount = " ≈ $ " + (this.data.money / this.payment.rate).toFixed(num) + '';
					} else {
						this.actualAmount = " ≈ " + this.payment.mark + (this.data.money / this.payment.rate).toFixed(num);
					}
				}
			},
			changeAmount2(vnum) {
				this.data.money = vnum ;
				var num = 2;
				if(this.payment.type){
					if (this.payment.type == 1) {
						if (this.payment.rate > 10000) {
							num = 8;
						} else if (this.payment.rate > 1000) {
							num = 6;
						} else if (this.payment.rate > 10) {
							num = 4;
						}
						this.actualAmount = " ≈ $ " + (this.data.money * this.payment.rate).toFixed(num) + ' ';
					} else {
						this.actualAmount = " ≈ $ "  + (this.data.money / this.payment.rate).toFixed(num);
					}
				}
			}
		}
	};
</script>

<style lang="less" scoped>
	.red_top_bg {
	}

	.balance {
		background: #ffffff;
		border-radius: 6px;
		padding: 20px 0px;
		margin: 10px;
		text-align: center;
		p:nth-child(1) {
			font-size: 26px;
			font-weight: bold;
			margin-bottom: 15px;
		}

		p:nth-child(2) {
			color: #999;
			font-weight: bold;
		}
	}

	.recharge_fs {
		margin-top: 10px;
		background: rgba(255, 255, 255, 1);
		border-radius: 6px;
		padding: 0 16px;
	}

	.recharge_box {
		width: 100%;
		height: 48px;
		background: rgba(255, 255, 255, 1);
		border-radius: 6px;
		margin-top: 12px;
		padding: 16px 11px;

		input {
			height: 18px;
			width: 100%;
			line-height: 18px;
			font-size: 14px;
		}
	}

	.form {
		margin: 10px;

		.recharge_wrap {
			width: 100%;
			background: #ffffff;
			border-radius: 6px;
			padding: 16px;
			margin-top: 10px;
			.flex_center {
			  justify-content: left;
			}
			.reason{
				width: 100%;
			}
			input {
				height: 30px;
				width: 40%;
				padding: 5px;
				line-height: 18px;
				margin-right: 5px;
				font-size: 12px;
				border: solid 1px #fce582;
			}
			div {
				span:nth-child(2){
					// font-size: 18px;
					// margin-right: 10px;
					// font-weight: bold;
				}
				// span:nth-child(3){
				// 	font-size: 14px;
				// 	width: 40%;
				// 	color: #999;
				// 	text-align: right;
				// }
			}

			p:nth-child(1) {
				font-size: 16px;
				font-weight: bold;
				color: #999;
				margin-bottom: 20px;
			}

			p:nth-child(3) {
				color: #999;
				margin-top: 20px;
			}

		}

		.tit {
			height: 54px;
			border-bottom: 1px solid #ECECEC;
			font-size: 16px;
			color: #999;
			font-weight: bold;
			line-height: 54px;
		}

		.item {
			height: 57px;
			border-bottom: 1px solid #ECECEC;
			display: flex;
			justify-content: flex-start;
			align-items: center;

			&:last-child {
				border-bottom: none;
			}

			.check {
				width: 16px;
				height: 16px;
				margin-left: 4px;
				background: url(../images/user/c2.png) no-repeat center center;
				background-size: 100% 100%;

				&.checked {
					background: url(../images/user/c1.png) no-repeat center center;
					background-size: 100% 100%;
				}
			}

			.re_icon {
				width: 20px;
				height: 20px;
				margin-left: 11px;

				img {
					width: 20px;
					height: 20px;
				}
			}

			.re_name {
				font-size: 16px;
				line-height: 22px;
				color: rgba(0, 0, 0, .8);
				margin-left: 4px;
			}

			.wx {
				background: url(../images/user/recharge3.png) no-repeat center center;
				background-size: 100% 100%;
			}

			.alipay {
				background: url(../images/user/recharge2.png) no-repeat center center;
				background-size: 100% 100%;
			}

			.usdt {
				background: url(../images/user/recharge1.png) no-repeat center center;
				background-size: 100% 100%;
			}

			.alipay_app {
				background: url(../images/user/recharge2.png) no-repeat center center;
				background-size: 100% 100%;
			}

			.bank {
				background: url(../images/user/recharge4.png) no-repeat center center;
				background-size: 100% 100%;
			}
		}
	}
	.tip{
		display: block;
		margin: 8px;
		padding: 16px;
		border-radius: 16px;
		background-color: #FFFFFF;
		line-height: 24px;
		color: #D20100cc;
		font-size: 12px;
	}
	.sbtn {
		margin: 20px auto;
	}
	.quick_wrap{
		margin-top: 3%;
		padding-top: 3%;
		background-color: #fff;
		p{
			font-size: 14px;
			font-weight: bold;
			line-height: 30px;
		}
		.flex_center{
			width: 100%;
			display: -webkit-box;
			display: -webkit-flex;
			display: flex;
			-webkit-flex-wrap: wrap;
			flex-wrap: wrap;
			span{
				width: 21%;
				display: block;
				height: 35px;
				line-height: 35px;
				font-size: 12px;
				background-color: #fce582;
				border: 1px solid #fce582;
				text-align: center;
				color: #191715;
				margin-right: 10px;
				margin-bottom: 10px;
				border-radius: 5px;
				font-weight: bold;
				max-width: 85px;
			}
		}
	}

	.finance-page {
		min-height: 100vh;
		padding-bottom: .48rem;
		box-sizing: border-box;
		background: radial-gradient(circle at 100% 0, rgba(255, 56, 92, .09), transparent 30%), #f7f7f7;
	}

	.finance-page .red_top_bg {
		height: 1.28rem;
		background: transparent;
		color: #222;
	}

	.finance-page .big_tit {
		top: .42rem;
		color: #222;
		font-size: .34667rem;
		font-weight: 700;
	}

	.finance-page .back_left {
		position: absolute;
		top: .3rem;
		left: .28rem;
		width: .48rem;
		height: .48rem;
		margin: 0;
		background: none;
	}

	.finance-page .back_left::after {
		color: #222;
		content: '‹';
		font-size: .64rem;
		font-weight: 300;
		line-height: .4rem;
	}

	.finance-page .top_right {
		top: .36rem;
		right: .36rem;
		color: #484848;
	}

	.finance-page .balance {
		margin: .08rem .4rem .3rem;
		padding: .36rem .4rem;
		border: .02667rem solid #ececec;
		border-radius: .26667rem;
		box-shadow: 0 .10667rem .26667rem rgba(0, 0, 0, .05);
	}

	.finance-page .balance p:nth-child(1) {
		margin-bottom: .12rem;
		color: #222;
		font-size: .58667rem;
		letter-spacing: -.02rem;
	}

	.finance-page .balance p:nth-child(2) {
		color: #717171;
		font-size: .25333rem;
		font-weight: 500;
	}

	.finance-page .form {
		margin: 0 .4rem;
	}

	.finance-page .form .recharge_wrap {
		margin: 0;
		padding: .4rem;
		border: .02667rem solid #ececec;
		border-radius: .26667rem;
		box-sizing: border-box;
		box-shadow: 0 .10667rem .26667rem rgba(0, 0, 0, .04);
	}

	.finance-page .form .recharge_wrap p:nth-child(1) {
		margin-bottom: .24rem;
		color: #484848;
		font-size: .28rem;
		font-weight: 600;
	}

	.finance-page .form .recharge_wrap input {
		width: 48%;
		height: .64rem;
		padding: 0;
		border: 0;
		border-bottom: .02667rem solid #ddd;
		border-radius: 0;
		color: #222;
		font-size: .4rem;
	}

	.finance-page .quick_wrap {
		margin-top: .32rem;
		padding-top: .28rem;
		border-top: .02667rem solid #f0f0f0;
	}

	.finance-page .quick_wrap .flex_center {
		gap: .16rem;
	}

	.finance-page .quick_wrap .flex_center span {
		width: 22%;
		height: .56rem;
		margin: 0;
		border: .02667rem solid #f0d5db;
		border-radius: .13333rem;
		background: #fff8f9;
		color: #484848;
		font-size: .22667rem;
		font-weight: 600;
		line-height: .56rem;
	}

	.finance-page .basic_btn {
		width: 100%;
		height: .96rem;
		margin: .32rem 0 0;
		border-radius: .2rem;
		background: #ff385c;
		box-shadow: 0 .13333rem .24rem rgba(255, 56, 92, .22);
		color: #fff;
		font-size: .32rem;
		font-weight: 600;
		line-height: .96rem;
	}

	.finance-page .tip {
		margin: .3rem .4rem 0;
		padding: .28rem .32rem;
		border: .02667rem solid #f0e3e5;
		border-radius: .2rem;
		background: #fff;
		color: #717171;
		font-size: .24rem;
		line-height: .4rem;
	}

	.finance-page {
		position: relative;
		min-height: 100vh;
		padding-bottom: 48px;
		background: radial-gradient(circle at 85% 5%, rgba(255, 77, 114, .13), transparent 35%), #f7f5f7;
	}

	.finance-page::before {
		position: absolute;
		top: 62px;
		right: 0;
		left: 0;
		height: 260px;
		background: url('../images/ban1/ppbg.png') no-repeat center top / 100% auto;
		content: '';
		opacity: .3;
		pointer-events: none;
	}

	.finance-page > * {
		position: relative;
		z-index: 1;
	}

	.finance-page .red_top_bg {
		height: 62px;
		background: transparent;
		box-shadow: none;
	}

	.finance-page .big_tit {
		top: 0;
		width: calc(100% - 112px);
		height: 62px;
		overflow: hidden;
		color: #222630;
		font-size: 16px;
		font-weight: 700;
		line-height: 62px;
		text-align: center;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.finance-page .back_left,
	.finance-page .top_right {
		position: absolute;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 40px;
		height: 40px;
		margin: 0;
		border: 1px solid rgba(39, 35, 42, .08);
		border-radius: 12px;
		background: rgba(255, 255, 255, .85);
		box-shadow: 0 4px 14px rgba(50, 28, 42, .05);
		color: #263344;
		cursor: pointer;
	}

	.finance-page .back_left {
		top: 11px;
		left: 16px;
	}

	.finance-page .back_left::after {
		width: 9px;
		height: 9px;
		border-bottom: 2px solid #263344;
		border-left: 2px solid #263344;
		color: transparent;
		content: '';
		font-size: 0;
		transform: rotate(45deg);
	}

	.finance-page .top_right {
		top: 11px;
		right: 16px;
		padding: 0;
	}

	.finance-page .balance {
		position: relative;
		overflow: hidden;
		margin: 14px 16px 18px;
		padding: 23px 24px 27px;
		border: 1px solid rgba(255, 255, 255, .1);
		border-radius: 20px;
		background: linear-gradient(135deg, #2a384b 0%, #192435 56%, #111a28 100%);
		box-shadow: 0 16px 32px rgba(22, 31, 45, .2);
		text-align: left;
	}

	.finance-page .balance::after {
		position: absolute;
		right: -40px;
		bottom: -80px;
		width: 210px;
		height: 210px;
		border: 1px solid rgba(255, 255, 255, .14);
		border-radius: 50%;
		content: '';
		pointer-events: none;
	}

	.balance-top {
		position: relative;
		z-index: 1;
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 12px;
		color: rgba(255, 255, 255, .75);
		font-size: 14px;
		font-weight: 500;
	}

	.visibility-button {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 30px;
		height: 30px;
		padding: 0;
		border: 1px solid rgba(255, 255, 255, .22);
		border-radius: 50%;
		background: rgba(255, 255, 255, .08);
		color: #fff;
		font-size: 16px;
		cursor: pointer;
	}

	.finance-page .balance p.balance-amount {
		position: relative;
		z-index: 1;
		margin: 16px 0 0;
		color: #fff;
		font-size: 16px;
		font-weight: 700;
		letter-spacing: -.5px;
		line-height: 1.2;
		word-break: break-all;
	}

	.finance-page .form {
		margin: 0 16px;
	}

	.finance-page .form .recharge_wrap {
		padding: 22px 20px 20px;
		border: 1px solid #f0e8eb;
		border-radius: 20px;
		background: #fff;
		box-shadow: 0 10px 28px rgba(50, 28, 42, .07);
	}

	.finance-page .form .recharge_wrap p.amount-title {
		margin: 0 0 14px;
		color: #28242b;
		font-size: 16px;
		font-weight: 700;
		line-height: 1.4;
	}

	.amount-entry {
		display: flex;
		align-items: center;
		gap: 12px;
		min-height: 58px;
		border-bottom: 1px solid #ebe6e9;
	}

	.finance-page .form .amount-entry input {
		flex: 1;
		min-width: 0;
		width: 100%;
		height: 58px;
		padding: 0;
		border: 0;
		outline: 0;
		background: transparent;
		color: #222630;
		font-size: 16px;
		font-weight: 700;
		line-height: 58px;
	}

	.amount-entry input::placeholder {
		color: #b0aab0;
		font-size: 14px;
		font-weight: 400;
	}

	.currency-mark {
		flex: 0 0 auto;
		padding: 5px 9px;
		border-radius: 8px;
		background: #fff1f5;
		color: #cf245d;
		font-size: 12px;
		font-weight: 700;
	}

	.converted-amount {
		min-height: 18px;
		margin-top: 9px;
		color: #88818a;
		font-size: 12px;
		line-height: 18px;
		text-align: right;
	}

	.finance-page .quick_wrap {
		margin-top: 18px;
		padding-top: 18px;
		border-top: 1px solid #f1edf0;
	}

	.amount-grid {
		display: grid;
		grid-template-columns: repeat(4, minmax(0, 1fr));
		gap: 8px;
	}

	.amount-grid button {
		min-width: 0;
		height: 39px;
		padding: 0 2px;
		border: 1px solid #eee6e9;
		border-radius: 9px;
		background: #faf8f9;
		color: #615b63;
		font-size: 12px;
		font-weight: 600;
		cursor: pointer;
	}

	.amount-grid button.selected {
		border-color: #e31c5f;
		background: #fff1f5;
		color: #cf245d;
		box-shadow: inset 0 0 0 1px rgba(227, 28, 95, .1);
	}

	.finance-page .basic_btn {
		display: block;
		width: 100%;
		height: 52px;
		margin: 20px 0 0;
		padding: 0;
		border: 0;
		border-radius: 13px;
		background: linear-gradient(100deg, #ff4d72, #d82162);
		box-shadow: 0 10px 22px rgba(227, 28, 95, .2);
		color: #fff;
		font-size: 16px;
		font-weight: 700;
		line-height: 52px;
		cursor: pointer;
	}

	.finance-page .tip {
		margin: 16px 16px 0;
		padding: 18px 20px;
		border: 1px solid #f0e8eb;
		border-left: 3px solid #e31c5f;
		border-radius: 14px;
		background: rgba(255, 255, 255, .9);
		box-shadow: 0 8px 24px rgba(50, 28, 42, .04);
		color: #77717a;
		font-size: 12px;
		line-height: 1.65;
	}

	.invest-page {
		font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "Microsoft YaHei", sans-serif;
		font-size: 14px;
	}

	.invest-page input,
	.invest-page button {
		font-family: inherit;
	}

	@media (max-width: 360px) {
		.finance-page .form .recharge_wrap {
			padding: 20px 16px;
		}

		.finance-page .form .amount-entry input {
			font-size: 16px;
		}

		.amount-grid {
			gap: 6px;
		}
	}
</style>
